<!-- 用户下拉信息 -->
<template>
  <AppHeaderDropdown right no-caret class="cpsp-appheader">
    <template slot="header">
      <!-- <img :src="imageUrl" class="img-avatar" v-b-tooltip.hover :title="userName" /> -->
      <strong>{{ userName }}</strong>
    </template>
    <template slot="dropdown" style="padding:0 !important">
      <b-dropdown-header tag="div" class="text-center ">
        <strong>账户</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="loginOut">
        <i class="fa fa-lock" /> 注销
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import jwtDecode from "jwt-decode";
import * as localStorageMgr from "../shared/localStorageMgr";
import * as sessionStorageMgr from "../shared/sessionStorageMgr";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  props: ["userName"],
  data: () => {
    return {
      itemsCount: 42,
      imageUrl: "/img/avatars/default_tx.jpg",
    };
  },
  mounted() {
    let _this = this;
    var access_token = localStorage.getItem("user_access_token");
    if (access_token) {
      _this.logined = true;
      _this.user_idx = jwtDecode(access_token).data.idx;
      _this.$api.apiGetUserInfo(_this.user_idx).then((data) => {
        _this.imageUrl =
          "https://newbox-app.oss-cn-hangzhou.aliyuncs.com/" +
          data.user.icon_url;
      });
    }
  },
  methods: {
    ///重新登录
    loginOut() {
      let account = this.$global.global_data.local_username;
      let locale = localStorageMgr.get(localStorageMgr.data.locale);
      localStorageMgr.clear();
      sessionStorageMgr.clear();
      if (account) {
        localStorageMgr.set(localStorageMgr.data.last_login_account, account);
      }
      if (locale) {
        localStorageMgr.set(localStorageMgr.data.locale, locale);
      }
      window.location.href = "/pages/Login?url=" + encodeURIComponent(window.location.href);
      // this.$router.push({ path: "/pages/login" }, () => { });
    },
  }
};
</script>

<style scoped>
.cpsp-appheader {}

.cpsp-appheader .dropdown-header {
  color: white;
  padding: 8px 20px;
  background: #ff9408;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.app-header .dropdown-item {
  min-width: auto !important;
}

.dropdown-menu .dropdown-menu-right .show ul {
  padding: 0 !important;
}
</style>
<style>
.cpsp-appheader {}

.cpsp-appheader .dropdown-menu {
  padding-top: 0rem !important;
}
</style>
